import { Map } from 'immutable';
import { actionTypes as CreateProjectDialogActionsType } from '../../../actions/Administration/MatSettingsPage/Dialogs/createProjectDialogActions.js';

let defaultState = {
  show: false,
  loading: false,
  itemToEdit: null,
  dialogData: null,
};

export default function(state = Map(defaultState), action) {

  switch (action.type) {
    case CreateProjectDialogActionsType.CREATE_PROJECT_DIALOG_SHOW:
      state = state.set('itemToEdit', action.payload);
      return state.set('show',true);

    case CreateProjectDialogActionsType.CREATE_PROJECT_DIALOG_HIDE:
      return Map(defaultState);

    case CreateProjectDialogActionsType.CREATE_PROJECT_DIALOG_SUBMIT_IN_PROGRESS:
      return state.set("loading", true);

    case CreateProjectDialogActionsType.CREATE_PROJECT_DIALOG_SUBMIT_FINISHED:
      return state.set("loading", false);

    case CreateProjectDialogActionsType.CREATE_PROJECT_DIALOG_FETCH_DATA_READY:
      return state.set("dialogData", action.payload);

    default:
      return state;
  }

}







